import { all, fork } from 'redux-saga/effects';
import featureUpdateNoticeListSaga from './featureUpdateNoticeListSaga';
import featureUpdateNoticeFormSaga from './featureUpdateNoticeFormSaga';

export default function* featureUpdateNoticeSaga() {
  yield all([fork(featureUpdateNoticeListSaga), fork(featureUpdateNoticeFormSaga)]);
}
